<ng-container>
  <div class="banner flex flex-row xs:flex-col flex-wrap xs:gap-[32px] justify-center items-center">
    <img class="image" src="/assets/img/installer-guy.png" />
    <div class="flex flex-col gap-[16px] xs:gap-[12px] justify-start items-start flex-1">
      <div class="header">{{ 'PAID_FEATURES_BANNER.TITLE' | translate }}</div>
      <div class="feature-list flex flex-row lt-md:flex-col flex-wrap justify-start items-start">
        <div class="flex flex-col">
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_1' | translate }}
            </div>
          </div>
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_2' | translate }}
            </div>
          </div>
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_3' | translate }}
            </div>
          </div>
        </div>
        <div class="flex flex-col lt-md:!hidden">
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_4' | translate }}
            </div>
          </div>
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_5' | translate }}
            </div>
          </div>
          <div class="flex flex-row">
            <mat-icon class="check">check</mat-icon>
            <div class="feature">
              {{ 'EVENT_BANNER.FEATURE_6' | translate }}
            </div>
          </div>
        </div>
        <div class="feature more-features-item !hidden lt-md:!block">
          {{ 'EVENT_BANNER.MORE_FEATURES' | translate }}
        </div>
      </div>
    </div>
    <div
      *ngIf="getPrice() | async as price; else loading"
      class="price-container flex flex-col justify-center items-center"
    >
      <div class="flex flex-col justify-center items-center">
        <div class="price-info flex flex-row gap-[8px] justify-center items-center">
          <span>{{ 'PAID_FEATURES_BANNER.FROM' | translate }}</span>
          <span class="price" data-at-package-price>
            {{ (price.price / 12).toFixed(2) }}
            {{ price.currency }}
          </span>
          <span>{{ 'PAID_FEATURES_BANNER.MONTHLY' | translate }}</span>
        </div>
        <div class="vat-info">
          {{ 'PAID_FEATURES_BANNER.VAT_INFORMATION' | translate }}
        </div>
      </div>
      <button
        gtm="onGoToPage"
        gtmAction="Booking"
        gtmCategory="eventBanner"
        mat-raised-button
        color="primary"
        [routerLink]="['/booking']"
      >
        {{ 'PAID_FEATURES_BANNER.BTN.COMPARE_PACKAGES' | translate }}
        <mat-icon iconPositionEnd class="arrow-icon">arrow_forward</mat-icon>
      </button>
    </div>
    <ng-template #loading>
      <vi-loader data-at-loader [isLoading]="true"></vi-loader>
    </ng-template>
    <button
      class="close-button"
      mat-icon-button
      gtm="onClose"
      gtmCategory="eventBanner"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-container>
